function AboutAttributesChemicals() {
  return (
    <div id="section44">
      <h3>Chemicals</h3>
      <p>
        We use the term “Chemicals” to refer to a broad variety of entities, including therapeutics,
        endogenous (e.g. endogenous metabolites) and exogenous chemicals (e.g. environmental factors,
        pesticides). Chemical information is extracted from the sentences containing gene and variant disease
        associations from publications and clinical trials.
        <br />
        Therapeutics include small molecules, proteins, enzymes and peptides, antibodies, antibody-drug
        conjugates, genes and oligonucleotides and cells.{' '}
      </p>
      <p>
        Chemicals in DISGENET are represented with the ChEMBL identifier, and mapped to several identifiers
        such as ChEBI, DrugBank, MeSH and PubChem.
        <br />
        Chemicals in DISGENET are annotated with:
        <ul>
          <li className="bullet-item">The ChEMBL identifier</li>
          <li className="bullet-item">The chemical name, obtained from ChEMBL</li>
          <li className="bullet-item">The number of Gene-Disease Associations (N. GDAs)</li>
          <li className="bullet-item">The number of Variant-Disease Associations (N. VDAs)</li>
          <li className="bullet-item">The number of publications with chemical mentions (N. PMIDS)</li>
          <li className="bullet-item">
            The number of publications that support GDAs with chemical mentions (N. PMIDs GDA)
          </li>
          <li className="bullet-item">
            The number of publications that support VDAs with chemical mentions (N. PMIDs VDA)
          </li>
          <li className="bullet-item">
            Chemical Type: Small molecule, Protein, Unknown, Antibody, Oligosaccharide, Antibody drug
            conjugate, Oligonucleotide, Enzyme, Gene and Cell. This information is obtained from ChEMBL.
          </li>
        </ul>
      </p>
    </div>
  );
}
export default AboutAttributesChemicals;
